// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__KyyW4","left":"styles_left__dE4j4","right":"styles_right__lNhVV"};